<!--
 * @Description: 翻料信息
-->
<template>
    <el-dialog :visible="visible" title="翻料信息" width="800px" @close="onClose" @open="onOpen">
        <BlockText :config="block" :detail="config.blockData" />
    </el-dialog>
</template>

<script>
    import BlockText from "./BlockText.vue"

    export default {
        components: {
            BlockText,
        },
        data() {
            return {
                block: [
                    { label: '翻料类型', field: ''},
                    { label: '余料翻料信息', field: ''},
                    { label: '翻出量', field: ''},
                    { label: '强度等级', field: ''},
                    { label: '性能等级', field: ''},
                    { label: '材料要求', field: ''},
                    { label: '特俗要求', field: ''},
                    { label: '其他要求', field: ''},
                    { label: '外加剂要求', field: ''},
                ],
            };
        },
        props: {
            config: {
                type: Object,
                default: () => ({}),
            },
            visible: {
                type: Boolean,
            },
        },
        methods: {
            onOpen() {},
            onClose() {
                this.$emit("update:visible", false)
            },
        },
    };
</script>
<style lang="scss" scoped>
.box {
    max-height: 500px;
    overflow-y: auto;
    padding-right: 10px;
}
</style>